var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DgButton',_vm._b({class:['dg-button-highlightable', { [`animation-${_vm.animationType}`]: _vm.highlight }],attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},'DgButton',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }